const config = {
  development: {
    API_BASE_URL: 'https://api.dashboard.safsims.flexisafapps-dev.com',
  },
  staging: {
    API_BASE_URL: 'https://api.dashboard.safsims.flexisafapps-stage.com',
  },
  production: {
    API_BASE_URL: 'https://api.dashboard.safsims.com',
  },
};

export default config[process.env.REACT_APP_ENV || process.env.NODE_ENV] || config.development;
